import { Box, CircularProgress, Skeleton, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';

import {
  getCheckingAvailabilityText,
  VARIANT_CHIP_HEIGHT,
  VENDOR_CHECK_SPINNER_SIZE,
  VENDOR_CHECK_SPINNER_SX,
} from '../../../constants/marketplace';
import { DRAWER_IMAGE_HEIGHT_DESKTOP, GALLERY_THUMBNAIL_SIZE, PILL_BORDER_RADIUS } from '../../../constants/ui';

interface IProps {
  vendor?: string;
}

const columnSx: SxProps<Theme> = { display: 'flex', flexDirection: 'column', gap: 2 };

const chipsColumnSx: SxProps<Theme> = { display: 'flex', flexDirection: 'column', gap: 1 };

const chipsRowSx: SxProps<Theme> = { display: 'flex', flexWrap: 'wrap', gap: 1 };

const statusSx: SxProps<Theme> = { display: 'flex', alignItems: 'center', gap: 1 };

const pillSx: SxProps<Theme> = { borderRadius: PILL_BORDER_RADIUS };

// Mirrors the real details layout block for block so the panel keeps its shape when content arrives.
export const MarketplaceDetailsSkeleton: React.FC<IProps> = ({ vendor }) => (
  <Box sx={columnSx}>
    <Skeleton variant="rectangular" height={DRAWER_IMAGE_HEIGHT_DESKTOP} sx={{ borderRadius: 1 }} />

    <Box sx={{ display: 'flex', gap: 1 }}>
      {[0, 1, 2].map((index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          width={GALLERY_THUMBNAIL_SIZE}
          height={GALLERY_THUMBNAIL_SIZE}
          sx={{ borderRadius: 1 }}
        />
      ))}
    </Box>

    <Skeleton variant="text" width="35%" />

    <Box>
      <Skeleton variant="text" />
      <Skeleton variant="text" />
      <Skeleton variant="text" width="60%" />
    </Box>

    <Box sx={chipsColumnSx}>
      <Skeleton variant="text" width="30%" />
      <Box sx={chipsRowSx}>
        {[0, 1, 2, 3].map((index) => (
          <Skeleton key={index} variant="rounded" width={96} height={VARIANT_CHIP_HEIGHT} sx={pillSx} />
        ))}
      </Box>
    </Box>

    <Box role="status" aria-live="polite" sx={statusSx}>
      <CircularProgress size={VENDOR_CHECK_SPINNER_SIZE} thickness={5} sx={VENDOR_CHECK_SPINNER_SX} />
      <Typography variant="body2" color="text.secondary">
        {getCheckingAvailabilityText(vendor)}
      </Typography>
    </Box>
  </Box>
);
